import { getMyAccountId } from "../utils/config";

export function addToCartAndOrderExpress({
  product,
  qty,
  user,
  addToCart,
  updateCartItem, // kept for interface compat, unused
  openInfoModal,
  notes,          // explicit notes override (e.g. from ProductDetail editor)
}) {
  if (user.idCustomer === null) {
    alert("Debe seleccionar un cliente!");
    return;
  }

  const MYACCOUNT_ID = getMyAccountId();
  const price = Number(product.unitPrice || 0);
  const porcentaje = Number(user?.porcentaje || 0) / 100;

  // Read current state from localStorage to compute merged qty/subtotal
  const saved = JSON.parse(localStorage.getItem("order_express_items") || "[]");
  const exists = saved.find((x) => x.idProduct === product.idProduct);

  let finalItem;

  if (exists) {
    const newQty = exists.qty + qty;
    const newSubtotalCents = Math.round(Math.round(price * 10000) * newQty / 100);
    const newSubtotalStr = (newSubtotalCents / 100).toFixed(2);
    const newTax = product.payTax
      ? (Math.round((newSubtotalCents * porcentaje) + Number.EPSILON) / 100).toFixed(2)
      : "0.00";

    finalItem = {
      ...exists,
      qty: newQty,
      subtotal: newSubtotalStr,
      tax: newTax,
      notes: notes ?? product.notes ?? exists.notes ?? null,
    };
  } else {
    const subtotalCents = Math.round(Math.round(price * 10000) * qty / 100);
    const subtotalStr = (subtotalCents / 100).toFixed(2);
    const tax = product.payTax
      ? (Math.round((subtotalCents * porcentaje) + Number.EPSILON) / 100).toFixed(2)
      : "0.00";

    finalItem = {
      img: `https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${product.productId}.jpg`,
      idProduct: product.idProduct,
      code: product.productId,
      description: product.productName,
      notes: notes ?? product.notes ?? null,
      price,
      qty,
      subtotal: subtotalStr,
      payTax: Boolean(product.payTax),
      tax,
      service: product.service || 0,
      acuerdo: product.acuerdo ?? false,
      categoryId: product.categoryId ?? null,
    };
  }

  // CartContext persists to order_express_items via its effect
  addToCart(finalItem);

  if (openInfoModal) {
    openInfoModal(finalItem);
  }
}
